import { WButton } from '@wareclouds/wareclouds-ui';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { COUNTRIES_REGIONAL_CONFIG } from '@wareclouds/frontend-common';
import { CONTEXT } from '../../../../config/consts/commons';

export default function WhatsAppButton({ phoneNumber, label }) {
  return (
    <WButton
      variant="contained"
      sx={{ backgroundColor: '#25D366' }}
      startIcon={<WhatsAppIcon />}
      label={label}
      onClick={() => {
        window.open(
          `https://wa.me/${COUNTRIES_REGIONAL_CONFIG[CONTEXT].intlCode}${phoneNumber}`,
          '_blank'
        );
      }}
      fullWidth
    />
  );
}
